var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentView,_vm._b({tag:"component",on:{"event":_vm.onEvent}},'component',_vm.currentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }